import { api, axiosInstance, GENERATE_AUDIO_BOOK } from "../apiurls/apiurls";
import {
  GENERATE_PERSONALIZED_CONTENT_COURSE,
  GENERATE_PERSONALIZED_CONTENT_SUBJECT,
  GENERATE_PERSONALIZED_CONTENT_TOPIC,
  GENERATE_PERSONALIZED_CONTENT_SUBTOPIC,
  CREATE_PERSONALIZED_CONTENT_COURSE,
  CREATE_PERSONALIZED_CONTENT_SUBJECT,
  CREATE_PERSONALIZED_CONTENT_TOPIC,
  CREATE_PERSONALIZED_CONTENT_SUBTOPIC,
  GET_PERSONALIZED_CONTENT_COURSE,
  GET_PERSONALIZED_CONTENT_SUBJECT,
  GET_PERSONALIZED_CONTENT_TOPIC,
  GET_PERSONALIZED_CONTENT_SUBTOPIC,
} from "../apiurls/apiurls";

const buildGeneratePayload = (pageId, token) => ({
  page: pageId,
  token: token,
});

export const generateCoursePersonalizedContent = async (pageId, token) => {
  try {
    const payload = buildGeneratePayload(pageId, token);
    const response = await api.socket(
      GENERATE_PERSONALIZED_CONTENT_COURSE,
      payload,
    );
    return response;
  } catch (error) {
    console.error("Error generating course personalized content:", error);
    throw error;
  }
};

export const generateSubjectPersonalizedContent = async (pageId, token) => {
  try {
    const payload = buildGeneratePayload(pageId, token);
    const response = await api.socket(
      GENERATE_PERSONALIZED_CONTENT_SUBJECT,
      payload,
    );
    return response;
  } catch (error) {
    console.error("Error generating subject personalized content:", error);
    throw error;
  }
};

export const generateTopicPersonalizedContent = async (pageId, token) => {
  try {
    const payload = buildGeneratePayload(pageId, token);
    const response = await api.socket(
      GENERATE_PERSONALIZED_CONTENT_TOPIC,
      payload,
    );
    return response;
  } catch (error) {
    console.error("Error generating topic personalized content:", error);
    throw error;
  }
};

export const generateSubtopicPersonalizedContent = async (pageId, token) => {
  try {
    const payload = buildGeneratePayload(pageId, token);
    const response = await api.socket(
      GENERATE_PERSONALIZED_CONTENT_SUBTOPIC,
      payload,
    );
    return response;
  } catch (error) {
    console.error("Error generating subtopic personalized content:", error);
    throw error;
  }
};

export const createCoursePersonalizedContent = async (payload) => {
  try {
    const response = await axiosInstance.post(
      CREATE_PERSONALIZED_CONTENT_COURSE,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating course personalized content:", error);
    throw error;
  }
};

export const createSubjectPersonalizedContent = async (payload) => {
  try {
    const response = await axiosInstance.post(
      CREATE_PERSONALIZED_CONTENT_SUBJECT,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating subject personalized content:", error);
    throw error;
  }
};

export const createTopicPersonalizedContent = async (payload) => {
  try {
    const response = await axiosInstance.post(
      CREATE_PERSONALIZED_CONTENT_TOPIC,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating topic personalized content:", error);
    throw error;
  }
};

export const createSubtopicPersonalizedContent = async (payload) => {
  try {
    const response = await axiosInstance.post(
      CREATE_PERSONALIZED_CONTENT_SUBTOPIC,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating subtopic personalized content:", error);
    throw error;
  }
};

export const getCoursePersonalizedContent = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_PERSONALIZED_CONTENT_COURSE, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching course personalized content:", error);
    throw error;
  }
};

export const getSubjectPersonalizedContent = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_PERSONALIZED_CONTENT_SUBJECT, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subject personalized content:", error);
    throw error;
  }
};

export const getTopicPersonalizedContent = async (params = {}) => {
  try {
    const response = await axiosInstance.get(GET_PERSONALIZED_CONTENT_TOPIC, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching topic personalized content:", error);
    throw error;
  }
};

export const getSubtopicPersonalizedContent = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      GET_PERSONALIZED_CONTENT_SUBTOPIC,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic personalized content:", error);
    throw error;
  }
};

export const generatePersonlizedContentAudiobook = async (layer, id, token) => {
  try {
    const payload = {
      field: layer,
      key: id,
      token: token,
    };
    const response = await api.socket(GENERATE_AUDIO_BOOK, payload);
    return response;
  } catch (error) {
    console.error("Error generating subject personalized content:", error);
    throw error;
  }
};
